import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-subscribe',
  templateUrl: './event-subscribe.component.html',
  styleUrls: ['./event-subscribe.component.scss']
})
export class EventSubscribeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
